import { 
  isVNode,
} from "vue";
export const renderInlineStyle = (rowHeight:number) => {
  return (
    <style>{`
       
        .scroll-render-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td{
          padding:0px;
          height:${rowHeight - 8 <= 0 ? "auto" : rowHeight + "px"};
        }
        .scroll-render-row-height-${rowHeight} .el-table__body td.el-table__cell.use-virtual-select>div.cell{
          overflow:hidden;
        }
        
        .scroll-render-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont {
          height:${rowHeight - 8 <= 0 ? "auto" : rowHeight + "px"};
          margin:-4px 0px;
          padding:8px 12px;
          line-height:1.2;
          overflow:auto;
          display:flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;

        } 

        .scroll-render-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar {
          width: 2px; /* 滚动条宽度 */
          height: 2px;
        }

        /* 滚动条轨道样式 */
        .scroll-render-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar-track {
          background-color: rgba(0,0,0,0.1); /* 轨道背景色 */
        }
        
        /* 滚动条滑块样式 */ 
        .scroll-render-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.1);  /* 滑块背景色 */
        }
        
        /* 滚动条滑块在鼠标悬停时的样式 */ 
        .scroll-render-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0,0,0,0.2);  /* 悬停时滑块背景色 */
        } 

        `}</style>
  );
};




export function extractTextFromVNode(vnode: any): string {
 
  if (typeof vnode=='number') {
    return vnode+'';
  }
  if (typeof vnode=='string') {
    return vnode;
  }
  if (Array.isArray(vnode)) {
    return vnode
      .map((childVNode) => extractTextFromVNode(childVNode))
      .join("");
  }
  if (isVNode(vnode)) {
    if(vnode.props&&vnode.props.modelValue &&typeof vnode.type=='object'){ //假如是组件
      return vnode.props.modelValue+""
    }
    if (vnode.children == null) {
      return vnode.children === null
        ? ""
        : (vnode.children as any).toString();
    }

    if (vnode.children && vnode.children.default && typeof vnode.children.default === 'function') {
      return (vnode.children.default()).toString()
    }
    if (Array.isArray(vnode.children)) {
      return vnode.children
        .map((childVNode) => extractTextFromVNode(childVNode))
        .join("");
    }

    return extractTextFromVNode(vnode.children);
  }

  if (typeof vnode === "string") {
    return vnode;
  }

  return "";
}
